import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { HyperlinkService } from '@shared/services/hyperlink.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SnackService } from '@shared/services/snack.service';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-hyperlink-create',
    templateUrl: './admin-hyperlink-create.component.html',
    styleUrls: ['./admin-hyperlink-create.component.scss'],
    standalone: false
})
export class AdminHyperlinkCreateComponent extends AdminActionsDirective {
    formGroup: UntypedFormGroup;

    constructor(
        private hyperlinkService: HyperlinkService,
        private fb: UntypedFormBuilder,
        private snack: SnackService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
        this.buildForm();
    }

    async updateItem(event: any): Promise<void> {
        this.disableSubmitter(event);

        if (this.formGroup.valid) {
            try {
                const result = await this.hyperlinkService.createItem(this.formGroup.value);
                this.snack.openSnackBarSuccess(`Hyperlink item ${result.title} created successfully.`);
                this.goToHyperlink(result);
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }

        this.enableSubmitter(event);
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            title: [null, Validators.required],
            titleDe: null,
            urlLink: [null, Validators.required],
            urlLinkDe: null,
            description: null,
            descriptionDe: null
        });
    }
}
